import React from 'react';

import CHUNK_TYPES from '@common/constants/ChunkTypes';
import { IChunkModel } from '@common/models/Chunks/Chunk';
import { IGradeBookModel } from '@common/models/GradeBooks/GradeBook';

import ChunkDictaphone from '../components/Chunks/Dictaphone';
import ChunkFile from '../components/Chunks/File';
import ChunkFormula from '../components/Chunks/Formula';
import ChunkImage from '../components/Chunks/Image';
import ChunkScorm from '../components/Chunks/Scorm';
import ChunkStudent from '../components/Chunks/Student';
import ChunkTitle from '../components/Chunks/Title';
import ChunkVideo from '../components/Chunks/Video';

const renderChunkContent = (
	chunkModel: IChunkModel,
	gradeBook: IGradeBookModel,
	disabled: boolean = false,
) => {
	const { name } = { ...chunkModel.chunk_type };
	switch (name.toLowerCase()) {
		case CHUNK_TYPES.IMAGE:
			return <ChunkImage chunkModel={chunkModel} />;
		case CHUNK_TYPES.TEXT:
			return null;
		case CHUNK_TYPES.VIDEO:
			return <ChunkVideo url={chunkModel.video?.url} />;
		case CHUNK_TYPES.TITLE:
			return <ChunkTitle chunkModel={chunkModel} />;
		case CHUNK_TYPES.FORMULA:
			return <ChunkFormula />;
		case CHUNK_TYPES.SCORM:
			return <ChunkScorm chunkModel={chunkModel} gradeBook={gradeBook} disabled={disabled} />;
		case CHUNK_TYPES.FILE:
			return <ChunkFile chunkModel={chunkModel} />;
		case CHUNK_TYPES.STUDENT:
			return <ChunkStudent chunkModel={chunkModel} disabled={disabled} />;
		case CHUNK_TYPES.DICTAPHONE:
			return <ChunkDictaphone chunkModel={chunkModel} hideDeleteButton={!!gradeBook.is_done} />;
		case CHUNK_TYPES.MEDIA:
			return <ChunkVideo url={chunkModel.media_url} />;
		default:
			return <div>Unknown Chunk Type</div>;
	}
};

export default renderChunkContent;
